import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import colors from '@kcftech/design-tokens/colors';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getLocallyStoredAccessToken } from 'contexts/UserContext';
import { useTheme } from 'styled-components';
import { ThemeType } from 'styles/colorMode';
import { buildRawSVG } from 'utils/svg';

// Raw SVG strings require hardcoded colors (CSS variables don't work)
const questionMarkSvgLight = buildRawSVG(faQuestionCircle, colors.navy['1000']);
const questionMarkSvgDark = buildRawSVG(faQuestionCircle, colors.grey['50']);
const questionMarkSvgByTheme: Record<ThemeType, string> = {
    light: questionMarkSvgLight,
    dark: questionMarkSvgDark,
    night: questionMarkSvgDark,
};

export function usePicture(path?: string) {
    const theme = useTheme();
    return useQuery({
        queryKey: ['picture', path, theme.colorMode],

        queryFn: async () => {
            if (!path) {
                return '';
            }

            const token = getLocallyStoredAccessToken();
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };
            const res = await fetch(path, { headers });
            if (!res.ok) {
                if (process.env.NODE_ENV === 'development' && path.includes('cIcon')) {
                    // stop yelling in the console, we don't copy these to devenvs
                    return URL.createObjectURL(
                        new Blob([questionMarkSvgByTheme[theme.colorMode]], {
                            type: 'image/svg+xml',
                        })
                    );
                }
                throw new Error('Could not fetch picture');
            }
            const blob = await res.blob();

            return URL.createObjectURL(blob).toString();
        },

        retry: false,
        refetchOnMount: false,
        placeholderData: keepPreviousData,
        staleTime: Infinity,

        // 1 hour
        gcTime: 1000 * 60 * 60,
    });
}
